export const environment = {
  keycloak: {
    url: window['env']['REACT_APP_KEYCLOAK_URL'] || 'http://localhost:8080',
    realm: window['env']['REACT_APP_KEYCLOAK_REALM'] || 'BeeCrew',
    client: window['env']['REACT_APP_KEYCLOAK_CLIENT'] || 'beecrew-rest-api',
  },
  loginUrl: window['env']['REACT_APP_LOGIN_REDIRECT'] || 'http://localhost:3000/login',
  googleLoginUrl:
    window['env']['REACT_APP_GOOGLE_LOGIN'] || 'http://localhost:4180/oauth2/start?rd=http://localhost:3000/',
  baseUrl: window['env']['REACT_APP_REQUEST_URL_BASE'] || 'http://localhost:8086/api/v1/',
  allowedDomains: window['env']['REACT_APP_ALLOWED_DOMAINS'] || 'bee2code.com,adcogito.com',
  publicUrl: window['env']['PUBLIC_URL'] || '',
  maxIconSizeMb: window['env']['REACT_APP_MAX_ICON_SIZE_IN_MB'] || 0.01,
  maxTechIconSizeMb: window['env']['REACT_APP_MAX_TECH_ICON_SIZE_IN_MB'] || 0.02,
  version: window['env']['REACT_APP_VERSION'] || '1.0.0',
}
